// mds-dojo — dijit/main — the `dijit` root object (real dijit/main.js exposes the
// dijit namespace object). Modules like place/registry hang back-compat aliases off
// it; also published on the global for legacy `window.dijit` lookups.
const dijit: any = (globalThis as any).dijit || {};
(globalThis as any).dijit = dijit;
export default dijit;
